/** Koşullu class birleştirici — bağımlılıksız (kriter 15: clsx'e gerek yok). */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
